// src/components/Navbar/Navbar.js
import React, { useState } from "react";
import { useCart } from "../../context/CartContext";
import { useNavigate } from "react-router-dom";
import MobileMenu from "./MobileMenu";
import "./Navbar.css";

const TSSLogo = () => (
  <svg width="60" height="64" viewBox="0 0 80 86" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="40" cy="30" rx="22" ry="24" fill="none" stroke="#1a1a1a" strokeWidth="3"/>
    <circle cx="28" cy="24" r="5" fill="#1a1a1a"/>
    <circle cx="52" cy="24" r="5" fill="#1a1a1a"/>
    <path d="M28 38 Q40 48 52 38" stroke="#1a1a1a" strokeWidth="2.5" fill="none"/>
    <line x1="40" y1="54" x2="28" y2="78" stroke="#1a1a1a" strokeWidth="3"/>
    <line x1="40" y1="54" x2="52" y2="78" stroke="#1a1a1a" strokeWidth="3"/>
    <line x1="20" y1="62" x2="60" y2="62" stroke="#1a1a1a" strokeWidth="2.5"/>
    <path d="M28 10 Q40 0 52 10" stroke="#1a1a1a" strokeWidth="2.5" fill="none"/>
    <text x="40" y="84" textAnchor="middle" fontSize="7" fontWeight="800" fill="#1a1a1a" fontFamily="'Barlow Condensed', sans-serif" letterSpacing="2">MEMBER</text>
  </svg>
);

export default function Navbar() {
  const { cartCount, wishlist } = useCart();
  const [search, setSearch] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <header className="navbar">
        {/* Hamburger */}
        <button className="navbar__hamburger" onClick={() => setMobileOpen(true)} aria-label="Menu">
          <span /><span /><span />
        </button>

        {/* Nav links */}
        <nav className="navbar__links">
          <a href="#" className="navbar__link navbar__link--active" onClick={() => navigate("/")}>MEN</a>
          <a href="#" className="navbar__link">WOMEN</a>
          <a href="#" className="navbar__link">SNEAKERS</a>
        </nav>

        {/* Logo center */}
        <div className="navbar__logo" onClick={() => navigate("/")} role="button" tabIndex={0}>
          <div className="navbar__logo-ghost">
            <svg viewBox="0 0 48 52" fill="none" width="42" height="46">
              <ellipse cx="24" cy="20" rx="15" ry="16" fill="none" stroke="#1a1a1a" strokeWidth="2.5"/>
              <circle cx="17" cy="15" r="3.5" fill="#1a1a1a"/>
              <circle cx="31" cy="15" r="3.5" fill="#1a1a1a"/>
              <path d="M17 25 Q24 31 31 25" stroke="#1a1a1a" strokeWidth="2" fill="none"/>
              <path d="M9 36 L24 36 L39 36 L39 52 L30 46 L24 52 L18 46 L9 52 Z" fill="#1a1a1a"/>
              <circle cx="17" cy="15" r="1.5" fill="white"/>
              <circle cx="31" cy="15" r="1.5" fill="white"/>
            </svg>
          </div>
          <div className="navbar__logo-text">
            <span>The Souled</span>
            <span>Store</span>
            <span className="navbar__logo-member">MEMBER</span>
          </div>
        </div>

        {/* Search */}
        <div className="navbar__search">
          <input
            type="text"
            placeholder="What are you looking for?"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <button className="navbar__search-mic" aria-label="Voice search">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2a3 3 0 0 1 3 3v7a3 3 0 0 1-6 0V5a3 3 0 0 1 3-3z"/>
              <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
              <line x1="12" y1="19" x2="12" y2="23"/>
              <line x1="8" y1="23" x2="16" y2="23"/>
            </svg>
          </button>
          <button className="navbar__search-btn" aria-label="Search">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
            </svg>
          </button>
        </div>

        {/* Icons */}
        <div className="navbar__icons">
          <button className="navbar__icon-btn" onClick={() => navigate("/account")} aria-label="Account">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
            </svg>
          </button>
          <button className="navbar__icon-btn" onClick={() => navigate("/wishlist")} aria-label="Wishlist">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
            {wishlist.length > 0 && <span className="navbar__badge">{wishlist.length}</span>}
          </button>
          <button className="navbar__icon-btn navbar__cart-btn" onClick={() => navigate("/cart")} aria-label="Cart">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>
            </svg>
            {cartCount > 0 && <span className="navbar__badge navbar__badge--red">{cartCount}</span>}
          </button>
        </div>
      </header>

      <MobileMenu open={mobileOpen} onClose={() => setMobileOpen(false)} />
    </>
  );
}
